<lm-list #lmlookuplist
    *ngIf="(listSpec && selectRequestData)"
    [listUrlInfo]="listUrlInfo"
    [listSpec]="listSpec"
    [selectRequestData]="selectRequestData"
    (listRowSelected)="onRowsSelected($event)"
    [ngStyle]="{'width': '100%'}"
    (titleChanged)="onTitleChanged($event)"
    (toolbarButtonEvent)="onToolbarButtonEvent($event)"
    (listDisplayed)="onListDisplayed()"
>
</lm-list>
